import api from '@/api/fetchClient'

export default {
  getVendors(params = {}) {
    let url = 'vendors'
    const queryParams = []

    if (params.search) {
      queryParams.push(`search=${encodeURIComponent(params.search)}`)
    }
    if (params.category) {
      queryParams.push(`category=${encodeURIComponent(params.category)}`)
    }

    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&')
    }

    return api.get(url, { authorized: true })
  },

  getVendorById(partyId) {
    return api.get(`vendors/${partyId}`, { authorized: true })
  },

  createVendor(payload) {
    return api.post('vendors', payload, { authorized: true })
  },

  updateVendor(partyId, payload) {
    return api.put(`vendors/${partyId}`, payload, { authorized: true })
  },

  deleteVendor(partyId) {
    return api.delete(`vendors/${partyId}`, { authorized: true })
  }
}
